import { ReactElement } from "react";
import { IUserInfo } from "../../messages/IAppInfo";
import { hasPermission } from "../common/ProtectedRoute";
import { NavLink } from "react-router-dom";
//import { get } from "http";


export default function NavigationItems(props: {
  userInfo: IUserInfo | null;
}): ReactElement {
  var userInfo = props.userInfo;

  function getNavLinkClass(props: { isActive: boolean }): string {
    if (userInfo?.eula_accepted || userInfo?.impersonated) {
      if (props.isActive) {
        return "active_page active";
      } else {
        return "active_page";
      }
    } else {
      return "disabled"
    }
  }

  function getNavLinkClassNonReact(): string {
    return getNavLinkClass({isActive:false});
  }

  if (props.userInfo !== null) {
    return (
      <>
        <li>
          {props.userInfo.has_course && (
            <NavLink className={getNavLinkClass} to="/content">
              Courses
            </NavLink>
          )}
        </li>
        <li>
          {props.userInfo.has_vm && (
            <a className={getNavLinkClassNonReact()} href="/labs/vms">
              Labs
            </a>
          )}
        </li>
        <li>
          {props.userInfo.has_assessment && (
            <NavLink className={getNavLinkClass} to="/assessments">
              Assessments
            </NavLink>
          )}
        </li>
        <li>
          {props.userInfo.has_course && hasPermission(props.userInfo, [ { permission: "demo" }]) && (
            <NavLink className={getNavLinkClass} to="/codereview">
              Code review
            </NavLink>
          )}
        </li>
        <li>
          <a className={getNavLinkClassNonReact()} href="/rewards">
            My progress
          </a>
        </li>
        <li>
          {props.userInfo.has_ctf && (
            <NavLink className={getNavLinkClass} to="/leaderboard">
              Leaderboard
            </NavLink>
          )}
        </li>
        <li>
          {hasPermission(props.userInfo, [
            { permission: "cohort_read_dashboard" }
          ]) && (
              <a className={getNavLinkClassNonReact()} href="/cohort-dashboard">
                Cohort dashboard
              </a>
            )}
        </li>
      </>
    );
  } else {
    return <></>;
  }
}
